import { combineEpics } from "redux-observable";
import { FeatureEffects } from "../features";
import { PagesEffects } from "../pages";

export const Effects = combineEpics(...FeatureEffects, ...PagesEffects);
